<template>
  <div class="d-flex" v-if="show">
    <template v-for="({name, path}, i) in links">
      <!-- @slot Для кастомизации элемента -->
      <slot name="item" v-bind:text="name" v-bind:path="path" v-bind:index="i">
        <div class="link" v-if="i === links.length - 1" :key="path">{{ name }}</div>
        <router-link v-else class="link" :to="path" :key="path">{{ name }}</router-link>
      </slot>
    </template>
  </div>
</template>

<script>
export default {
  name: 'bimBreadcrumbs',
  props: {
    /**
     * Скрыть, если выводится только один элемент
     * @param boolean
     * */
    hideAlone: Boolean,
    /**
     * Скрыть, если только один элемент
     * @param boolean
     * */
    hideHome: Boolean,
    /**
     * Скрыть текущий раздел
     * @param boolean
     * */
    hideCurrent: Boolean,
    /**
     * Склеивание данных вывода с массивом `arrayMerge` или замена
     * merge или replace, по умолчанию merge
     * @param string
     * */
    typeMerge: {
      type: String,
      default: 'merge'
    },
    /**
     * Массив с объектами для слияния с $route.matched или полной замены вывода
     * Состав объекта `{ path: 'ссылка', name: 'Наименование страницы' }`
     * @param array
     * */
    arrayMerge: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({ links: [] }),
  mounted () {
    this.render()
  },
  watch: {
    $route () {
      this.render()
    }
  },
  computed: {
    show () {
      return this.links.length && !(this.links.length === 1 && this.hideAlone)
    },
    matched () {
      const keys = Object.keys(this.$route.params)
      let matched = [...this.$route.matched]
      keys.forEach(key => {
        matched = matched.map(item => {
          item.path = item.path.replace(`:${key}`, this.$route.params[key])
          return item
        })
      })
      return matched
    }
  },
  methods: {
    /**
     * @description Формирование ссылок
     * */
    render () {
      this.$nextTick(() => {
        const array = this.matched.map(item => {
          const name = item.meta.routeName || item.name
          const path = item.path || '/'
          const check = !!name && !!path && !(this.hideHome && path === '/') && !(this.hideCurrent && path === this.$route.path)
          return check ? { name, path } : false
        }).filter(item => !!item)
        this.links = this.typeMerge === 'replace' ? this.arrayMerge : [...array, ...this.arrayMerge]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.link {
  color: rgba(77, 77, 77, .55);
  font-size: 14px; line-height: 1.2;
  text-decoration: none; letter-spacing: .2px;
  & + & {
    margin-left: 5px;
    &::before {
      content: '/';
      margin-right: 4px;
    }
  }
}
</style>
